import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { streamPost } from "../lib/api";

export default function AskWork({ pieceSlug, trackSlug, title, id = "ask" }) {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState("");
  const [asked, setAsked] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2 || busy) return;
    setBusy(true); setErr(""); setAnswer(""); setAsked(q);
    try {
      await streamPost("/ai/ask", { question: q, piece_slug: pieceSlug, track_slug: trackSlug }, (t) => setAnswer((a) => a + t));
      setQ("");
    } catch (e2) {
      setErr(e2.message);
    }
    setBusy(false);
  };

  return (
    <section className="border border-[var(--line)] p-5 sm:p-8" data-testid={`${id}-panel`}>
      <p className="eyebrow mb-3">Ask the work</p>
      <p className="f-serif italic text-xl sm:text-2xl leading-snug mb-6">Question {title ? <span className="not-italic f-display font-bold uppercase">{title}</span> : "it"} directly.</p>
      <form onSubmit={submit} className="flex items-end gap-3 border-b border-[var(--bone)] focus-within:border-[var(--signal)] transition-colors">
        <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={400} placeholder="What does it refuse to say?" className="flex-1 bg-transparent outline-none py-3 f-serif text-lg placeholder:text-[#7d7d77]" data-testid={`${id}-input`} />
        <button type="submit" disabled={busy} className="pb-3 f-mono text-xs uppercase tracking-[0.2em] flex items-center gap-2 hover:text-[var(--signal)] disabled:opacity-50" data-testid={`${id}-submit`}>
          {busy ? "Listening" : "Ask"} <ArrowRight size={14} />
        </button>
      </form>
      {(answer || err) && (
        <div className="mt-6" data-testid={`${id}-answer`}>
          <p className="f-mono text-[11px] text-[var(--ash)] mb-2">&rarr; {asked}</p>
          {err ? <p className="text-[var(--signal)]">{err}</p> : <p className="text-lg leading-relaxed text-[#d8d7d1] whitespace-pre-line">{answer}</p>}
        </div>
      )}
      <p className="f-mono text-[11px] text-[var(--ash)] mt-6">AI responses, drawn only from this work. A few questions per day.</p>
    </section>
  );
}
